/**
 * JavaScript Minify Tool
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';

export const JsMinifyTool: ITransformerTool = {
  id: 'js-minify',
  name: 'JavaScript Minify',
  description: 'Minify JavaScript using Terser',
  version: '1.0.0',
  type: 'transformer',
  category: 'Formatters & Minifiers',
  keywords: ['javascript', 'js', 'minify', 'compress'],

  supportedInputTypes: [SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.TEXT,

  attributes: [
    {
      name: 'mangle',
      type: 'boolean',
      label: 'Mangle Names',
      defaultValue: true,
      description: 'Shorten variable and function names',
    },
    {
      name: 'compress',
      type: 'boolean',
      label: 'Compress',
      defaultValue: true,
      description: 'Apply compression optimizations',
    },
    {
      name: 'module',
      type: 'boolean',
      label: 'ES Module',
      defaultValue: false,
      description: 'Treat input as an ES module',
    },
  ],

  async transform(input: string, config: Record<string, unknown>): Promise<string> {
    try {
      const { minify } = await import('terser');
      const result = await minify(String(input ?? ''), {
        module: config.module === true,
        mangle: config.mangle !== false,
        compress: config.compress !== false,
      });

      if (result.code == null) {
        throw ToolError.execution('Minification failed (no output produced)');
      }

      return result.code;
    } catch (e) {
      if (e instanceof ToolError) throw e;
      const message = e instanceof Error ? e.message : 'Failed to minify JavaScript';
      throw ToolError.execution(message);
    }
  },
};
